import { useMemo } from 'react';
import type { DSComboboxT } from '../react-desc-prop-types.js';

export const useOptionsPerSection = (correctOptions: DSComboboxT.OptionTypes[]) =>
  useMemo(() => {
    const result: DSComboboxT.OptionTypes[] = [];
    let currentSection: DSComboboxT.ItemSectionOptions | null = null;

    correctOptions.forEach((item) => {
      if (item.type === 'section') {
        // Start a new section
        currentSection = {
          dsId: item.dsId,
          type: item.type,
          label: item.label,
          options: [],
        };
        result.push(currentSection);
      } else if ((item.type === 'option' || item.type === 'separator') && currentSection) {
        // Add option to the current section's options array
        currentSection.options.push(item);
      } else if (item.type === 'option' || item.type === 'creatable' || item.type === 'separator') {
        // If we encounter an option without a section, push it to the result array
        result.push(item);
      }
    });
    return result;
  }, [correctOptions]);
